import { Component } from '@angular/core';
import { DataServiceProvider } from '../../providers/data-service/data-service';
import { ViewController } from 'ionic-angular';

/**
 * Generated class for the TypesModalComponent component.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
 * for more info on Angular Components.
 */
@Component({
  selector: 'types-modal',
  templateUrl: 'types-modal.html'
})
export class TypesModalComponent {
  types: any = {};
  typesArray: any[] = [];
  standardType: any;

  constructor(
    public viewCtrl: ViewController,
    private dataService: DataServiceProvider,
  ) {
    this.standardType = dataService.standardType;
    this.types = dataService.getTypes();
    for (let type in this.types){
       this.typesArray.push(type)
    }    
  }

  save() {
    this.dataService.setTypes(this.types);
    this.dataService.setStandardType(this.standardType);
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/components/types-modal/types-modal.ts